var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgApple = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 17.64 19.27"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.25 5.2C8.09 4.15 6.97 1.68 5.91.71 5.82.63 5.79.49 5.86.39c.12-.19.3-.32.52-.37.1-.02.19 0 .26.09.76.93 1.9 2.99 2.2 5.1-.42.73-.31.4-.57 0zm1.18.01c-1.02-2.39.9-4.14 3.18-4.35.31 1.82-.29 5-3.18 4.35z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.36 4.61c1.61.55 3.36.6 4.95-.05 2.78-1.13 5.54.04 6.2 3.1.76 3.51-2.04 9.18-3.71 10.76-1.18 1.12-2.8 1.02-4.06.28-.52-.31-1.17-.3-1.68.02-1.24.79-2.91.73-4.08-.39-2.1-1.99-4.1-6.01-3.98-9.65.12-3.46 3.3-5.11 6.35-4.07z",
  fill: "currentColor"
})));
export default SvgApple;